export const FEATURE_FLAGS = ['forms', 'home'] as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[number];

const isKnownFeatureFlag = (name: string): name is FeatureFlag => FEATURE_FLAGS.some(flag => flag === name);

// Unknown names are dropped, so a stale entry left in an env never breaks the app.
export const parseFeatureFlags = (rawValue: string | undefined): FeatureFlag[] =>
  (rawValue ?? '')
    .split(',')
    .map(name => name.trim())
    .filter(isKnownFeatureFlag);

const enabledFeatureFlags = parseFeatureFlags(process.env.REACT_APP_FEATURE_FLAGS);

export const isFeatureFlagEnabled = (flag: FeatureFlag): boolean => enabledFeatureFlags.includes(flag);
